<div
  *transloco="let t; scope: 'featureDataManagement'"
  class="h-full flex flex-col"
>
  <bd-page-header
    class="mt-[28px] mb-8"
    [titleText]="{
      textKey: 'dataManagement.label',
      tScope: 'featureDataManagement',
    }"
    [actions]="actionButtonsForHeader"
  />
  <div class="h-2/3 min-h-fit content-center">
    <bd-call-to-action
      data-id="no-data-management-content"
      icon="ui-cactus"
      [title]="{
        textKey: 'dataManagement.callToAction.title',
        tScope: 'featureDataManagement',
      }"
      [subtitle]="{
        textKey: 'dataManagement.callToAction.subtitle',
        tScope: 'featureDataManagement',
      }"
    >
    </bd-call-to-action>
  </div>
</div>
